export default __webpack_public_path__ + "images/6986dd342dbcf8060c2e60b4d6a9da0c-hannukuh_small.webp";